// extracted by mini-css-extract-plugin
module.exports = {"section":"events-marquee-module--section--W0VA3","section__row":"events-marquee-module--section__row--1bNUm","request":"events-marquee-module--request--2ENfq"};